import { configureStore } from '@reduxjs/toolkit';
import { authReducer, meReducer } from './authSlice';
import { rysApi } from '@/api/rysApi';
import { rysErrorMiddleware } from '@/api/errorMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    me: meReducer,
    [rysApi.reducerPath]: rysApi.reducer,
  },
  middleware: getDefault => getDefault().concat(rysApi.middleware, rysErrorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
